import { ProfitAndLossVoucherRowsData } from "@/types/profit-and-loss-voucher-rows-api";
import { api, withErrorHandling } from "./api";
import qs from "qs";

export const getProfitAndLossVoucherRows = async (
  clientId: string,
  connectionIds: string[],
  fromYear: number,
  fromMonth: number,
  toYear: number,
  toMonth: number,
  account?: string
): Promise<ProfitAndLossVoucherRowsData> => {
  console.log("1");
  const response = await withErrorHandling(() =>
    api.get<ProfitAndLossVoucherRowsData>(
      `/clients/${clientId}/report/profit-and-loss/voucher-rows`,
      {
        params: {
          clientId,
          fromYear,
          fromMonth,
          toYear,
          toMonth,
          connectionIds: connectionIds[0],
          account,
        },
        paramsSerializer: (p) => qs.stringify(p, { arrayFormat: "repeat" }),
      }
    )
  );
  console.log("2");
  return response.data;
};
